import { render, staticRenderFns } from "./AddToChannel.vue?vue&type=template&id=ed5bd132&scoped=true&"
import script from "./AddToChannel.vue?vue&type=script&lang=js&"
export * from "./AddToChannel.vue?vue&type=script&lang=js&"
import style0 from "./AddToChannel.vue?vue&type=style&index=0&id=ed5bd132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5bd132",
  null
  
)

export default component.exports